module.exports = __webpack_public_path__ + "img/the-cottages-sign.08fe1d3f.jpg";